import React, { Dispatch, SetStateAction, useState, createContext } from 'react'

export type HeaderState = {
  expandedMenu?: boolean | string
  expandedSubMenu: boolean
  openedMenu: boolean
  affixedSubBar: boolean
  notificationHeight: number
}

interface HeaderContextState {
  headerState: HeaderState
  setHeaderState: Dispatch<SetStateAction<HeaderState>>
}

const defaultState = {
  headerState: {
    expandedMenu: false,
    expandedSubMenu: false,
    openedMenu: false,
    affixedSubBar: false,
    notificationHeight: 0
  },
  setHeaderState: () => {}
}

export const HeaderContext = createContext<HeaderContextState>(defaultState)

export const HeaderProvider: React.FC = ({ children }) => {
  const [headerState, setHeaderState] = useState<HeaderState>(
    defaultState.headerState
  )

  return (
    <HeaderContext.Provider
      value={{
        headerState,
        setHeaderState
      }}
    >
      {children}
    </HeaderContext.Provider>
  )
}
